import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Col, Image, Row, Table } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'

export default function MRPlywood() {
    let image = useLocation().state.image

    return (
        <div>
            <Row className='mx-0' style={{ marginBottom: '61px' }}>
                <Col md={{ order: 'last' }} className='position-relative w-100 col-md-6 col-12 product-page-image-section mt-5 mt-md-0'>
                    <Image className='product-page-image position-absolute ' src={image} />
                </Col>
                <Col md={{ order: 'first' }} className='col-md-6 col-12'>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>ABOUT THE<br /> PRODUCT</h3>
                    </AnimationOnScroll>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.3em' }}>
                            MR Grade Ply popularly called the Commercial Ply is known for its high resistance to moisture in
                            both damp and humid conditions. Veneers with moisture resistant properties are stacked and bound
                            together with an adhesive that is arid which helps create strong, durable plies that are resilient
                            to plywood warping.
                            <br /><br />
                            Moisture Resistant MR plywood, is an indoor grade plywood which is perfect for cabinets, home and office
                            interiors. It holds well in both dry & wet conditions and is advised not to expose to water as it is not
                            waterproof.</p>
                    </AnimationOnScroll>
                </Col>
            </Row>
            <Row className='mx-0 justify-content-between' style={{ marginTop: '109px' }}>
                <Col md={2} className='d-flex align-items-center'>
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }}>Product Specification</h3></Col>
                <Col md={9}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <Table responsive>
                            <thead style={{ color: '#FFF' }}>
                                <tr>
                                    <th className='text-start'>TEST</th>
                                    <th className='text-start'>ISI SPECIFIED VALUE</th>
                                    <th className='text-start'>RESULT OBTAINED</th>
                                </tr>
                            </thead>
                            <tbody style={{fontWeight:'500'}}>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Dimension</td>
                                    <td className='text-start'>{`Length +6mm`}<br />
                                        {`Width +3mm`}<br />
                                        {`Thickness ≥ 6mm-±`}<br />
                                        {`5%, < 6mm-±10%`}</td>
                                    <td className='text-start'>Within Limit</td>
                                </tr>
                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Sp.Gravity</td>
                                    <td className='text-start'></td>
                                    <td className='text-start'>{`>7`}</td>
                                </tr>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Moisture Content</td>
                                    <td className='text-start'>5%-15%</td>
                                    <td className='text-start'>8%</td>
                                </tr>
                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Resistance to Micro-organism -Adhesion to plywood</td>
                                    <td className='text-start'>Min.Pass Standard</td>
                                    <td className='text-start'>Excellent</td>
                                </tr>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Static Bending Test<br />
                                        Modulus of Elasticity<br />
                                        -Along the grain Avg.+<br />
                                        -Across the grain Avg.+</td>
                                    <td className='text-start'>Min.5000 N/sq.mm<br />
                                        Min.2500 N/sq.mm</td>
                                    <td className='text-start'>6500 N/sq.mm<br />
                                        3000 N/sq.mm</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Modulus of Rupture<br />
                                        -Along the grain Avg.+<br />
                                        -Across the grain Avg.+</td>
                                    <td className='text-start'>Min.40 N/sq.mm<br />
                                        Min.20 N/sq.mm</td>
                                    <td className='text-start'>56 N/sq.mm<br />
                                        30 N/sq.mm</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Resistance to water (3 cycles of 8 hr<br />
                                        Boiling & 16 hr Drying at 65 ℃) -<br />
                                        Adhesion to plywood</td>
                                    <td className='text-start'>Min.Pass Standard</td>
                                    <td className='text-start'>Excellent</td>
                                </tr>
                            </tbody>
                        </Table>
                    </AnimationOnScroll>
                </Col>
            </Row>
        </div>
    )
}
